export enum PostManagerRoute {
  Create = 'create',
  Crop = 'crop',
  Update = 'update',
  Reject = 'reject',
}
